<!--
Bonos Clases - Lista de responsables de clases por plantel y su estatus de validación.
Los datos provienen de asistencias.visuales (misma fuente que VisualizadorEntradas).
Validado = el plantel tuvo todos los teachers con entrada correcta y se registró en bonos_clases_correctas.
-->

<template>
  <v-container class="mt-4 ml-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title primary-title>
            <span class="text-subtitle-1">Bonos Clases - Responsables</span>
            <v-spacer></v-spacer>

            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12" md="3">
                <v-text-field
                  filled
                  label="Fecha"
                  type="date"
                  hide-details
                  v-model="fecha"
                  dense
                  @keyup.enter="initialize()"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <label>Turno</label>
                <v-radio-group v-model="turno" row hide-details dense>
                  <v-radio label="Matutino" :value="1"></v-radio>
                  <v-radio label="Vespertino" :value="2"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" md="5">
                <v-text-field
                  name="name"
                  label="Buscar"
                  id="id"
                  filled
                  dense
                  hide-details
                  append-icon="mdi-magnify"
                  v-model="search"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headers"
                  :items="listaResponsables"
                  class="elevation-0"
                  :search="search"
                  :page.sync="page"
                  @page-count="pageCount = $event"
                  :mobile-breakpoint="100"
                  dense
                >
                  <template v-slot:item.responsable="{ item }">
                    {{ item.responsable || '—' }}
                  </template>
                  <template v-slot:item.validado="{ item }">
                    <v-chip v-if="item.validado" small color="success" dark>Validado</v-chip>
                    <v-chip v-else small color="grey" dark>No validado</v-chip>
                  </template>
                  <template v-slot:item.monto="{ item }">
                    ${{ (item.monto != null ? item.monto : 200).toFixed(2) }}
                  </template>
                  <template v-slot:item.aceptado="{ item }">
                    <v-chip v-if="item.aceptado" small color="success" dark>Aceptado</v-chip>
                    <v-chip
                      v-else-if="item.id_responsable"
                      small
                      color="grey"
                      dark
                      class="cursor-pointer"
                      @click="abrirDialogAceptarBono(item)"
                    >
                      Pendiente
                    </v-chip>
                    <v-chip v-else small color="grey" dark>Pendiente</v-chip>
                  </template>
                  <template v-slot:no-data>
                    <span class="text-body-2 grey--text">No hay responsables para esta fecha. Asigna responsables en Coordinación de sucursales.</span>
                    <br/>
                    <v-btn color="primary" @click="initialize" small class="mt-2">Actualizar</v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Modal Aceptar Bono -->
    <v-dialog v-model="dialogAceptarBono" max-width="450" persistent>
      <v-card>
        <v-card-title class="text-subtitle-1">
          Aceptar bono
        </v-card-title>
        <v-card-text v-if="itemAceptarBono" class="black--text">
          ¿Deseas aceptar el bono de <strong>${{ (itemAceptarBono.monto || 200).toFixed(2) }}</strong> para
          <strong>{{ itemAceptarBono.responsable }}</strong> en <strong>{{ itemAceptarBono.plantel }}</strong>?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            dark
            small
            tile
            @click="dialogAceptarBono = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="green"
            dark
            small
            tile
            :loading="cargarAceptar"
            @click="aceptarBono()"
          >
            Aceptar bono
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <carga v-if="cargar" />
  </v-container>
</template>
  <script>
  import axios from 'axios';
  import { mapGetters } from "vuex";
  // Componentes
  import Alerta from "@/components/alertas/Alerta.vue";
  import carga from "@/components/alertas/carga.vue";
  
  import validarErrores from "@/mixins/validarErrores";
  import funcionesExcel from "@/mixins/funcionesExcel";
  
  export default {
    mixins: [validarErrores, funcionesExcel],
  
    components: {
      Alerta,
      carga,
    },
  
    data: () => ({
      // Alertas
      parametros: {
        dialogError: false,
        mensaje: "",
        color: "",
      },
  
      respuestaAlerta: false,
      loader: true,
      cargar: false,
  
      dialog: false,
      dialogDelete: false,
      dialogAceptarBono: false,
      itemAceptarBono: null,
      cargarAceptar: false,
      turno: 1,
      headers: [
        { text: "Plantel"      , value: "plantel", align: "start" },
        { text: "Responsable"  , value: "responsable" },
        { text: "Validado"     , value: "validado", align: "center" },
        { text: "Monto"        , value: "monto", align: "end" },
        { text: "Aceptado"     , value: "aceptado", align: "center" }
      ],
      listaResponsables: [],
  
      fecha: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      // tabla
      search: "",
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
    }),
  
    computed: {
      ...mapGetters("login", ["getdatosUsuarioERPERP"]),
    },
  
    watch: {
      turno() {
        this.initialize();
      },
    },

    created() {
      this.initialize();
    },
  
    methods: {
      initialize() {
        this.listaResponsables = [];
        this.cargar = true;

        const payload = {
          dia: this.fecha,
          turno: this.turno
        };

        this.$http
          .post("asistencias.visuales", payload)
          .then((response) => {
            const planteles = response.data.plantelesActivos || [];
            const rows = [];
            planteles.forEach((p) => {
              const responsables = p.responsableClases || p.responsable_clases || [];
              const validado = !!(p.plantelCompleto);
              if (responsables.length === 0) {
                rows.push({
                  plantel: p.plantel || '',
                  responsable: 'Sin asignar',
                  id_responsable: null,
                  validado: validado,
                  monto: 200,
                  aceptado: false
                });
              } else {
                responsables.forEach((r) => {
                  rows.push({
                    plantel: p.plantel || '',
                    responsable: r.nombre_completo || r.nombre_usuario || '—',
                    id_responsable: r.id_usuario_oficial || r.id_usuario || r.id,
                    validado: validado,
                    monto: 200,
                    aceptado: false
                  });
                });
              }
            });
            this.listaResponsables = rows;
            return this.cargarNominaBonoclases();
          })
          .catch((error) => {
            this.validarError(error.response && error.response.data ? error.response.data.message : 'Error al cargar');
          })
          .finally(() => {
            this.cargar = false;
          });
      },

      cargarNominaBonoclases() {
        return this.$http
          .post("bono.clases.nomina.por.fecha", { fecha: this.fecha })
          .then((response) => {
            const registros = response.data.registros || response.data.respuesta || [];
            const mapa = {};
            registros.forEach((rec) => {
              const data = { monto: parseFloat(rec.bono_clases) || 200, aceptado: rec.estatus === 1 || rec.estatus === '1' };
              if (rec.id_empleado != null) mapa[String(rec.id_empleado)] = data;
              if (rec.id_usuario != null) mapa[String(rec.id_usuario)] = data;
            });
            this.listaResponsables.forEach((row) => {
              if (row.id_responsable != null) {
                const m = mapa[String(row.id_responsable)];
                if (m) {
                  row.monto = m.monto;
                  row.aceptado = m.aceptado;
                }
              }
            });
          })
          .catch(() => {});
      },

      abrirDialogAceptarBono(item) {
        this.itemAceptarBono = item;
        this.dialogAceptarBono = true;
      },

      aceptarBono() {
        if (!this.itemAceptarBono) return;
        this.cargarAceptar = true;
        const payload = {
          id_responsable: this.itemAceptarBono.id_responsable,
          fecha: this.fecha,
          bono_clases: this.itemAceptarBono.monto || 200,
          modifico: this.getdatosUsuarioERPERP.iderp
        };
        this.$http
          .post("bonoclases.aceptar", payload)
          .then(() => {
            this.validarSuccess("Bono aceptado correctamente");
            this.dialogAceptarBono = false;
            this.itemAceptarBono = null;
            this.initialize();
          })
          .catch((error) => {
            this.validarError(error.response && error.response.data ? error.response.data.message : "Error al aceptar bono");
          })
          .finally(() => {
            this.cargarAceptar = false;
          });
      },
    },
  };
  </script>
  